<template lang="pug">
tr(:id="tr_id" v-show="has_data")
  td(v-for="attr in form_block.visible_attributes()")
    label(:for="`medication_${tr_id}_${attr}`")
      .hidden1(style="visibility:hidden;height:0;margin:0")
        input(type="text", :id="`medication_${tr_id}_${attr}`", :value="rfb.entity_attrs[attr]", :required="form_block.required_attrs.includes(attr)")
      .foundation-message.hidden
        | is required
    | {{entity_attrs[attr]}}
  td(v-for="cf in form_block.custom_fields")
    | {{rfb.custom_attrs[cf.id].join('-')}}
  td.narrow.right.medication-link
    medication-form(v-if="editing"
      :entity_attrs="entity_attrs" :attrs="form_block.attrs" :required-attrs="form_block.required_attrs"
      @save="onSave", @cancel="onCancel" :top="false"
    )
    a.button.edit-button.secondary(@click.prevent="onEdit") {{t('app.registration.medication.edit')}}
    | &nbsp;
    a.button.secondary(@click.prevent="$emit('delete')") {{t('app.registration.medication.remove')}}
</template>
<script>
import medicationForm from '../../form_part/_medication_form'
export default{
  name: "FormBlockContentPartMedication",
  components: {medicationForm},
  props: {
    object:     {type: Object, required: true},
    form_block: {type: Object, required: true},
    rfb:        {type: Object, required: true},
  },
  emits: {
    delete: {},
    change: {},
  },
  data(){
    return {
      editing: false,
    }
  },
  watch:{
    "form_block.prefetch_new_element"(){
      console.log("implement medications reload")
    },
  },
  computed: {
    registration: function registration() {
      return this.state.current_reg;
    },
    tr_id(){        return 1 },
    has_data(){     return Object.keys(this.entity_attrs).length > 0 },
    entity_attrs(){ return {...this.object, ...this.rfb.entity_attrs} }
  },
  methods: {
    onEdit(){   this.editing = true },
    onCancel(){ this.editing = false },
    onSave(newObj){
      this.$emit('change', newObj)
      this.onCancel()
    },
  }
}
</script>
<style scoped>
td{
    text-align: left !important;
}
</style>